module.exports = __webpack_public_path__ + "img/adminLogo.4cd1ac86.png";